
// Feature T1 - 100d badge
function waitForElement(selector, callback) {
  //const element = document.querySelector(selector);
  const element = document.querySelector("#MainContent " + selector);

  if (element) {
    callback(element);
    return;
  }

  const observer = new MutationObserver(() => {
    //const element = document.querySelector(selector); Below is opt:
    const element = document.querySelector("#MainContent " + selector);

    if (element) {
      observer.disconnect();
      callback(element);
    }
  });

  /*
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  */

    observer.observe(document.querySelector("#MainContent") || document.body, {
    childList: true,
    subtree: true
    });

}

//if on normal earbuds, add class for identification.
if (window.location.href.includes("motorcycle-earplugs-27") || window.location.href.includes("27-db-2")) {
    document.body.classList.add("reg-earbuds");
}

const badge = `
<div class="guarantee-badge">
    <svg class="shield" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2L19 5V11C19 16 15.8 20.2 12 22C8.2 20.2 5 16 5 11V5L12 2Z" fill="#2563EB"></path>
        <path d="M8.5 12.3L10.8 14.6L15.8 9.6" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>

    <div class="badge-text">
        <strong>100-Day</strong>
        <span>Money-Back Guarantee</span>
    </div>
</div>
<style>
/* only display for returning. */
.first-time-visitor .guarantee-badge {
    display: none;
}

.returning-visitor .guarantee-badge {
    display: flex;
}

.guarantee-badge {
    position: absolute;
    z-index: 1000;
    left: -10px;
    top: -2px;
    align-items: center;
    max-width: 60% !important;
}

svg.shield {
    width: 85px;
    height: auto;
}

svg.shield path {
    fill: #121212 !important;
}


.badge-text {
    font-size: 13.5px;
    line-height: 1.1;
    font-family: 'Poppins';
    letter-spacing: normal;
    margin-left: -2px;
    color: black;
}

/*reg earbuds different styling*/
.reg-earbuds .guarantee-badge {
    left: unset;
    right: -2%;
    /* small mobiles 0*/
    max-width: 50% !important;
}

.reg-earbuds .badge-text {
    max-width: 200px;
}

/* in case of alternate pdp (shopify) templ, need to avoid overflow*/
.product__media-item.grid__item.slider__slide,
modal-opener {
    overflow: hidden;
    position: relative;
}


@media only screen and (min-width: 999px) {
    .badge-text {
        font-size: 16px;

    }

    .guarantee-badge {
        max-width: 50% !important;
    }

    svg.shield {
        width: 90px;
        height: auto;
    }

    .reg-earbuds svg.shield {
        width: 75px;
        height: auto;
    }


}
</style>
`;


//for only 1 img.
waitForElement('.product-form .gem-slider-item[grid-index="1"]', (element) => {
    let ribbonexists = document.querySelector(".guarantee-badge");
    if (ribbonexists) return;
    element.insertAdjacentHTML("afterbegin", badge);
});